import React,{Component, useEffect, useState } from "react";
import {
  FiHome,
  FiAirplay,
  FiTruck,
  FiUser,
  FiMessageSquare,
  FiCheckSquare,
  FiFood,
  FiCheck,
  FiThumbsUp,
} from "react-icons/all";
import { Restaurant } from "@material-ui/icons";

const SidebarItems = [
  {
    name: "Home",
    route: "/",
    icon: <FiHome />,
  },

  {
    name: "Products",
    route: "/products",
    icon: <FiAirplay />,
  },
  {
    name: "Users",
    route: "/users",
    icon: <FiUser />,
  },

  {
    name: "Errands",
    route: "/errands",
    icon: <FiTruck />,
  },

  {
    name: "Orders",
    route: "/orders",
    icon: <FiCheckSquare />,
  },

  {
    name: "Messages",
    route: "/messages",
    icon: <FiMessageSquare />,
  },

  {
    name: "Feedback",
    route: "feedback",
    icon: <FiThumbsUp />,
  },
  {
    name: "OrdersDelivered",
    route: "/ordersdelivered",
    icon: <FiCheck />,
  },
  {
    name: "Restaurants",
    route: "/restaurants",
    icon: <Restaurant />,
  },
];

export default SidebarItems